import React from 'react';
import { cn } from '../../lib/utils';

const GlassButton = React.forwardRef(({ 
  className, 
  variant = 'primary',
  size = 'default',
  glow = false,
  children, 
  ...props 
}, ref) => {
  const variants = {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    glass: 'glass-medium text-foreground hover:glass-heavy rounded-2xl px-6 py-3 font-semibold transition-all duration-300',
    outline: 'border-2 border-primary/30 text-primary hover:bg-primary/10 rounded-2xl px-6 py-3 font-semibold backdrop-blur-sm transition-all duration-300'
  };

  const sizes = {
    sm: 'px-4 py-2 text-sm',
    default: 'px-6 py-3',
    lg: 'px-8 py-4 text-lg'
  };

  const glowEffect = glow ? 'glow-primary' : '';

  return (
    <button
      ref={ref}
      className={cn(
        variants[variant],
        sizes[size],
        glowEffect,
        'active:scale-95 transition-transform duration-150',
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
});

GlassButton.displayName = 'GlassButton';

export { GlassButton };